<template>
  <div class="mobile_navigate">
    <ul class="mobile_navigate_box">
      <li>
        <router-link to="/home">
          <el-image src="https://websiteofficial.s3.us-east-2.amazonaws.com/file/img/logo/logo2.png" fit="fill" class="logo">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </router-link>
      </li>
      <li class="more">
        <div>
          <div :class="['iconfont', 'icon-gengduo1']" @click="toggleMenu"></div>
        </div>

        <transition name="fade-slide">
          <el-menu v-show="selectMore" default-active="/home" class="el-menu-vertical-demo select_More" @select="handleSelect" router background-color="#2c3e50" text-color="#ecf0f1" active-text-color="#f39c12">
            <el-menu-item index="/home">Home</el-menu-item>

            <el-submenu v-for="item in menus" :key="item.index" :index="item.index">
              <template slot="title">
                <span v-html="item.title"></span>
              </template>
              <el-menu-item-group>
                <el-menu-item v-for="child in item.children" :key="child.index" :index="child.index">
                  <span v-if="!child.isExternal" v-html="child.label"></span>
                  <span class="sup_class" v-else>
                    <a style="display: block;color: #fff" class="vertical-align: super" :href="child.index" target="_blank" rel="noopener noreferrer" v-html="child.label" @click.stop></a>
                  </span>

                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-menu-item index="/join">Join Us</el-menu-item>
            <el-menu-item index="/media">Media</el-menu-item>
          </el-menu>
        </transition>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "MobileHeader",
  data() {
    return {
      selectMore: false,
      menus: [
        {
          index: "/products",
          title: "Products & Services",
          children: [
            { index: "/products", label: "Products & Services" },
            { index: "/products/order", label: "How to Order" },
            { index: "/products/Brochures", label: "Product Brochures" },
            { index: "/products/ngs", label: "AilisNGS<sup style='vertical-align: super'>®</sup>" },
            { index: "/products/wes", label: "Exome Sequencing (WES)" },
            { index: "/products/gene", label: "Gene Panels" },
            { index: "/products/lowWgs", label: "Low-Pass WGS" },
            { index: "/products/mito", label: "Mito Genome Sequencing" },
            { index: "/products/reanalysis", label: "NGS Data Reanalysis" },
            { index: "/products/wgs", label: "WGS" },
            { index: "/products/f8", label: "F8 Inversions" },
            { index: "/products/Fragile", label: "Fragile X Repeat Expansion" },
            // {
            //   index: "https://websiteofficial.s3.us-east-2.amazonaws.com/file/pdf/Products/order/Fragile+X+Repeat+Expansion+Analysis.pdf",
            //   label: "Fragile X Repeat Expansion",
            //   isExternal: true
            // },
          ],
        },
        {
          index: "/about",
          title: "About AiLife",
          children: [
            { index: "/about", label: "About AiLife" },
            { index: "/about/people", label: "Our People" },
            { index: "/about/mission", label: "Our Mission" },
            { index: "/about/licenses", label: "Our Licenses" },
            { index: "/about/publications", label: "Our Publications" },
            { index: "/about/cantact", label: "Contact Us" },
            { index: "/about/privacy", label: "Privacy Policy" },
          ],
        },
        {
          index: "/tools",
          title: "Tools",
          children: [
            { index: "/tools", label: "Tools" },
            {
              index: "https://report.ailifeus.com",
              label: "AilisReport<sup style='vertical-align: super'>®</sup>",
              isExternal: true
            },
            { index: "/tools/AutoHPO", label: "AutoHPO" },
            { index: "/tools/DiseaseRK", label: "DiseaseRK" },
          ],
        },
      ],
    };
  },
  methods: {
    toggleMenu() {
      this.selectMore = !this.selectMore;
    },
    handleSelect() {
      this.selectMore = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile_navigate {
  box-sizing: border-box;
  width: 100%;
  height: 80px;
  color: $color_white;
  background: $color_default;
  padding: 0 10px;

  .logo {
    width: 130px;
    height: 70px;
  }

  .mobile_navigate_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    list-style: none;
    padding: 0;
    margin: 0;

    .more {
      height: 80px;
      display: flex;
      align-items: center;
      position: relative;

      .iconfont {
        font-size: 32px;
        cursor: pointer;
        color: #ecf0f1;
        transition: color 0.3s ease;
      }

      .select_More {
        position: absolute;
        top: 80px;
        right: -10px;
        min-width: 280px;
        max-height: calc(100vh - 80px);
        overflow-y: auto;
        background-color: #333;
        border-radius: 0 0 12px 12px;
        padding: 12px 0;
        z-index: 1000;

        /* Custom menu item styles */
        ::v-deep .el-menu-item,
        ::v-deep .el-submenu__title {
          height: 48px;
          line-height: 48px;

          a {
            display: block;
            width: 100%;
            height: 100%;
            color: inherit;
            text-decoration: none;
          }
        }

        /* Scrollbar styling */
        &::-webkit-scrollbar {
          width: 6px;
        }
        &::-webkit-scrollbar-thumb {
          background-color: rgba(243, 156, 18, 0.7);
          border-radius: 3px;
        }
      }
    }
  }
}

/* Animation */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/header/header.vue